module.exports = __webpack_public_path__ + "img/video.32221391.svg";